export default "skymp5-front/8f69aee7b394f3105a40a6c2bc9f5613.gif";